import { render, staticRenderFns } from "./ProcessoInput.vue?vue&type=template&id=0b3b5032"
import script from "./ProcessoInput.vue?vue&type=script&lang=js"
export * from "./ProcessoInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports